'use strict';

orderService.$inject = ["api", "$http", "$q", "OrderOverviewItem", "Order"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderService = orderService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function orderService(api, $http, $q, OrderOverviewItem, Order) {
    return {
        getByCriteria: getByCriteria,
        getById: getById,
        setOrderDeliveryDate: setOrderDeliveryDate
    };

    function getByCriteria(searchValue, page, itemsPerPage, sortProperty, sortAsc, sellerId) {
        var params = {
            Number: searchValue,
            Skip: itemsPerPage * (page - 1),
            Take: itemsPerPage,
            OrderBy: sortProperty,
            OrderAsc: sortAsc,
            SellerId: sellerId
        };

        return api.orderSearch.execute(params).$promise.then(function (searchResponse) {
            return {
                totalItems: searchResponse.count,
                orders: _lodash2.default.map(searchResponse.results, function (i) {
                    return OrderOverviewItem.create(i);
                })
            };
        });
    }

    function getById(id) {
        return $q.all([api.orders.get({ id: id }).$promise]).then(function (results) {
            var order = Order.create(results[0]);

            if (order.shippingNotes) {
                order.shippingNotes.forEach(function (note, i) {
                    getShippingNoteDetail(order.id, note.warehouseCode, note.shippingNoteNumber).then(function (result) {
                        order.shippingNotes[i].detail = result;
                        return result;
                    });
                });
            }

            return order;
        });
    }

    function getShippingNoteDetail(id, warehouseCode, shippingNote) {
        return api.shippingNoteSearch.execute({ id: id, warehouseCode: warehouseCode, shippingNote: shippingNote }).$promise.then(function (result) {
            return result;
        });
    }

    function setOrderDeliveryDate(order, newDeliveryDate) {
        return api.setOrderDeliveryDate.execute({ id: order.id, deliveryDate: newDeliveryDate, version: order.version }).$promise.then(function () {
            return getById(order.id).then(function (order) {
                return order;
            });
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/orderService.js
// module id = 818
// module chunks = 0